module.exports = _.attempt;